// This file is generated by Style Dictionary
const tokens = {
  chip: '32px',
  fabButton: '32px',
  field: '4px',
  filterButton: '4px',
  interaction: '4px',
  menu: '4px',
  surfaceCoreSmall: '4px',
  surfaceDomainMedium: '8px',
  surfaceDomainSmall: '4px',
};
export default tokens;
